<template>
  <div>
    <!-- ------ -->
    <div class="t_h2_txt1">
      <el-button v-if="authjson.authjson(['9-2'])" class="reset_btn" @click="open_place_order()" size="medium">{{$t('bank_card.place_order')}}</el-button>
      <el-button v-if="authjson.authjson(['9-3'])" class="reset_btn" @click="view_contract()" size="medium">{{$t('bank_card.View_the_contract')}}</el-button>
      <el-button v-if="authjson.authjson(['9-4'])" class="reset_btn" @click="to_info()" size="medium">{{$t('bank_card.check_an_order')}}</el-button>
    </div>

    <div class="th_info">
        <div class="th_info_top">
          {{$t('bank_card.Full_Contract_Summary')}} ( {{ order_id }} )
        </div>
        <div class="th_info_main">

          <div class="i_table">
            <div class="i_table_t1">
              <div class="i_table_t2">
                <table>
                  <tr>
                    <td colspan="2" class="font_color">{{$t('new1_txt.Contract')}}</td>
                  </tr>
                  <tr>
                    <td class="td_left">{{$t('bank_card.total_amount')}}</td>
                    <td class="td_right">{{ info_data.contracted_quantity }}</td>
                  </tr>
                  <tr>
                    <td class="td_left">{{$t('bank_card.Contracted_Paid')}}</td>
                    <td class="td_right">{{ info_data.contracted_quantity_paid }}</td>
                  </tr>
                  <tr>
                    <td class="td_left">{{$t('new1_txt.Total_N')}}</td>
                    <td class="td_right">{{ info_data.total_natural_replacement_qty }}</td>
                  </tr>
                  <tr>
                    <td class="td_left">{{$t('new1_txt.Total_E')}}</td>
                    <td class="td_right">{{ info_data.total_exceptional_replacement_qty }}</td>
                  </tr>
                  <tr>
                    <td class="td_left">{{$t('bank_card.Card_Qty_Order')}}</td>
                    <td class="td_right">{{ info_data.card_qty_available_for_order }}</td>
                  </tr>
                  <tr>
                    <td class="td_left">{{$t('bank_card.Total_Cards_Ordered')}}</td>
                    <td class="td_right">{{ info_data.total_cards_ordered }}</td>
                  </tr>
                  <tr>
                    <td class="td_left">{{$t('bank_card.Total_Cards_Allocated')}}</td>
                    <td class="td_right">{{ info_data.total_cards_allocated }}</td>
                  </tr>
                  <tr>
                    <td class="td_left">{{$t('new1_txt.Natural_R')}}</td>
                    <td class="td_right">{{ info_data.natural_replacement }}</td>
                  </tr>
                  <tr>
                    <td class="td_left">{{$t('new1_txt.Exceptional_R')}}</td>
                    <td class="td_right">{{ info_data.exceptional_replacement }}</td>
                  </tr>
                </table>
              </div>

              <div class="i_table_t2">
                <table>
                  <tr>
                    <td colspan="2" class="font_color">{{$t('new1_txt.Applications')}}</td>
                  </tr>
                  <tr>
                    <td class="td_left">{{$t('bank_card.users_kyc_approved')}}</td>
                    <td class="td_right">{{ info_data.total_users_kyc_approved }}</td>
                  </tr>
                  <tr>
                    <td class="td_left">&nbsp;</td>
                    <td class="td_right">&nbsp;</td>
                  </tr>
                  <tr>
                    <td class="td_left">&nbsp;</td>
                    <td class="td_right">&nbsp;</td>
                  </tr>
                  <tr>
                    <td class="td_left">&nbsp;</td>
                    <td class="td_right">&nbsp;</td>
                  </tr>
                  <tr>
                    <td class="td_left">&nbsp;</td>
                    <td class="td_right">&nbsp;</td>
                  </tr>
                  <tr>
                    <td class="td_left">&nbsp;</td>
                    <td class="td_right">&nbsp;</td>
                  </tr>
                  <tr>
                    <td class="td_left">&nbsp;</td>
                    <td class="td_right">&nbsp;</td>
                  </tr>
                  <tr>
                    <td class="td_left">{{$t('new1_txt.Cards_N')}}</td>
                    <td class="td_right">{{ info_data.cards_pending_natural_replacement }}</td>
                  </tr>
                  <tr>
                    <td class="td_left">{{$t('new1_txt.Cards_E')}}</td>
                    <td class="td_right">{{ info_data.cards_pending_exceptional_replacement }}</td>
                  </tr>
                </table>
              </div>
            </div>

            <div class="div_br">&nbsp;</div>

            <div class="i_table_t1">
              <div class="i_table_t2">
                <table>
                  <tr>
                    <td colspan="2" class="font_color">{{$t('bank_card.Order_Summary_Page')}}</td>
                  </tr>
                  <tr>
                    <td class="td_left">{{$t('bank_card.Card_Qty_Allocation')}}</td>
                    <td class="td_right">{{ info_data.card_qty_pending_allocation }}</td>
                  </tr>
                  <tr>
                    <td class="td_left">{{$t('bank_card.Card_Qty_Bind')}}</td>
                    <td class="td_right">{{ info_data.card_qty_available_for_bind }}</td>
                  </tr>
                  <tr>
                    <td class="td_left font_color">{{$t('bank_card.Cards_ordered_available')}}</td>
                    <td class="td_right">{{ info_data.cards_ordered_and_available }}</td>
                  </tr>
                  <tr>
                    <td class="td_left font_color">{{$t('bank_card.Total_Cards_Used')}}</td>
                    <td class="td_right">{{ info_data.total_cards_used }}</td>
                  </tr>
                </table>
              </div>

              <div class="i_table_t2">
                <table>
                  <tr>
                    <td class="td_left font_color">{{$t('new1_txt.total_approved')}}</td>
                    <td class="td_right">{{ info_data.current_users_pending_kyc }}</td>
                  </tr>
                  <tr>
                    <td class="td_left font_color">{{$t('bank_card.pending_consolidation')}}</td>
                    <td class="td_right">{{ info_data.current_users_pending_consolidation }}</td>
                  </tr>
                  <tr>
                    <td class="td_left font_color">{{$t('bank_card.pending_payment')}}</td>
                    <td class="td_right">{{ info_data.current_users_pending_payment }}</td>
                  </tr>
                  <tr>
                    <td class="td_left font_color">{{$t('bank_card.pending_users')}}</td>
                    <td class="td_right">{{ info_data.pending_users }}</td>
                  </tr>
                  <tr>
                    <td class="td_left">&nbsp;</td>
                    <td class="td_right">&nbsp;</td>
                  </tr>
                </table>
              </div>
            </div>

            <div class="div_br">&nbsp;</div>

            <div class="i_table_t1">
              <div class="i_table_t2">
                <table>
                  <tr>
                    <td class="td_left">{{$t('bank_card.Card_Qty_print')}}</td>
                    <td class="td_right">{{ info_data.card_qty_reserved_for_print }}</td>
                  </tr>
                  <tr>
                    <td class="td_left">{{$t('bank_card.Card_Qty_pending_Bind')}}</td>
                    <td class="td_right">{{ info_data.card_qty_printed_pending_bind }}</td>
                  </tr>
                  <tr>
                    <td class="td_left">{{$t('bank_card.Card_Qty_Activation')}}</td>
                    <td class="td_right">{{ info_data.card_qty_awaiting_activation }}</td>
                  </tr>
                  <tr>
                    <td class="td_left">{{$t('bank_card.Total_Cards_Activated')}}</td>
                    <td class="td_right">{{ info_data.total_cards_activated }}</td>
                  </tr>
                </table>
              </div>

              <div class="i_table_t2">
                <table>
                  <tr>
                    <td class="td_left">{{$t('bank_card.users_reserved_print')}}</td>
                    <td class="td_right">{{ info_data.current_users_reserved_for_print }}</td>
                  </tr>
                  <tr>
                    <td class="td_left">{{$t('bank_card.printed_pending_bind')}}</td>
                    <td class="td_right">{{ info_data.current_users_printed_pending_bind }}</td>
                  </tr>
                  <tr>
                    <td class="td_left">{{$t('bank_card.awaiting_activation')}}</td>
                    <td class="td_right">{{ info_data.current_users_awaiting_activation }}</td>
                  </tr>
                  <tr>
                    <td class="td_left">{{$t('bank_card.with_card_activated')}}</td>
                    <td class="td_right">{{ info_data.total_users_with_card_activated }}</td>
                  </tr>
                </table>
              </div>
            </div>

            <div class="div_br">&nbsp;</div>

            <div class="i_table_t1">
              <div class="i_table_t2">
                <table>
                  <tr>
                    <td class="td_left">{{$t('bank_card.Total_Cards_Bind')}}</td>
                    <td class="td_right">{{ info_data.total_cards_bind }}</td>
                  </tr>
                </table>
              </div>

              <div class="i_table_t2">
                <table>
                  <tr>
                    <td class="td_left">{{$t('bank_card.with_card_bind')}}</td>
                    <td class="td_right">{{ info_data.total_users_with_card_bind }}</td>
                  </tr>
                </table>
              </div>
            </div>

            <div class="Notes_box">
              <div>{{$t('new1_txt.Notes')}}</div>
              <div>{{$t('new1_txt.Notes_1')}}</div>
              <div>{{$t('new1_txt.Notes_2')}}</div>
              <div>{{$t('new1_txt.Notes_3')}}</div>
              <div>{{$t('new1_txt.Notes_4')}}</div>
              <div>{{$t('new1_txt.Notes_5')}}</div>
              <div>{{$t('new1_txt.Notes_6')}}</div>
              <div>{{$t('new1_txt.Notes_7')}}</div>
              <div>{{$t('new1_txt.Notes_8')}}</div>
            </div>

          </div>
          
        </div>
    </div>




    <!-- 下单 弹框 -->
    <el-dialog
      :title="$t('bank_card.place_order')"
      :visible.sync="place_order_dlg"
      custom-class="dlg element_input add_dlg app_dlg"
      append-to-body
      width="640px"
    >
      <div class="dlg_body">

        <div class="d_body">
          <el-form class="dlg_form dlg_form2" label-position="top">
            <el-form-item :label="$t('bank_card.branded_card_level')">
              <el-input v-model="order_form.level" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$t('bank_card.branded_card_category')">
              <el-select v-model="order_form.card_name" :placeholder="` `" disabled>
                <el-option v-for="item in order_form.category_list" :key="item.value" :label="item.name" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item :label="$t('bank_card.card_array')">
              <el-input v-model="card_array_name" disabled></el-input>
            </el-form-item> -->
            <el-form-item :label="$t('bank_card.order_num')">
              <el-input v-model="order_form.amount"></el-input>
              <div class="inp_btm_title">{{$t('bank_card.left_amount')}} : {{ order_form.left_amount }}</div>
              <div class="inp_btm_title">{{$t('bank_card.Minimum_order_quantity')}} : {{ min_amount }}</div>
            </el-form-item>
            <el-form-item :label="$t('main.text620')">
              <el-input type="textarea" v-model="order_form.remark" :autosize="{ minRows: 3, maxRows: 3 }"  resize='none' ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="place_order_dlg = false" class="cancel_btn border_set_color2">
            {{$t('main.text7')}}
        </el-button>
        <el-button type="primary" class="confirm_btn" @click="confirm">
            {{$t('main.text130')}}
        </el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import { createOrder,statistics } from "@/api/api";

export default {
  data() {
    return {
      // card_level:'',//卡级别 1Premier 2Premium
      // card_category:'',//1VISA 2Mastercard 3UnionPay
      
      place_order_dlg:false,
      order_form:{
        level:"",
        card_name:this.$route.query.card_category,
        amount:0,
        category_list:[],
        left_amount:0,
        remark:'',
      },
      
      order_id:this.$route.query.id,
      card_level:this.$route.query.card_level,
      min_amount:this.$route.query.min_amount,
      left_amount:this.$route.query.left_amount,
      card_category:this.$route.query.card_category,
      card_level_name:this.$route.query.card_level_name,
      card_array_name:this.$route.query.card_array_name,

      info_data:{},

    };
  },
  beforeDestroy() {
    sessionStorage.removeItem("top_title_name");
  },
  mounted() {
    sessionStorage.setItem("top_title_name", ' ');
    this.get_list();
  },
  methods: {
    async get_list() {
      const res = await statistics({tx_id:this.order_id});
      if (res.data.code !== 200) {
        return this.message.ismessage('error',res.data.msg);
      }
      this.info_data = res.data.data;
      // console.log(res.data.data);
    },
    
    open_place_order(){
      // "card_level": 1, 卡级别 1Premier 2 Prestige
      // "card_category": "1,2", 数组字符串 1VISA 2Mastercard 3UnionPay
      // "left_amount": 当前可下订单数量

      // if(this.card_level==1){
      //   this.order_form.level=this.$t('bank_card.Premier');
      // }else{
      //   this.order_form.level=this.$t('bank_card.Prestige');
      // }
      this.order_form.level=this.card_level_name;

      const c_list = [...this.card_category];
      const c_list2 = [];
      for (const i of c_list) {
        if(i==1){
          c_list2.push({"name":this.$t('bank_card.VISA'),'value':i})
        }else if(i==2){
          c_list2.push({"name":this.$t('bank_card.Mastercard'),'value':i})
        }else if(i==3){
          c_list2.push({"name":this.$t('bank_card.UnionPay'),'value':i})
        }
      }

      
      // this.order_form.card_name = '';
      this.order_form.amount = '';
      this.order_form.category_list = c_list2;
      this.order_form.left_amount = this.left_amount;
      this.order_form.remark = '';
      this.place_order_dlg = true;
      // console.log(this.order_form);
    },
    async confirm(){
      if (!this.order_form.card_name) {
        return this.message.ismessage('error',this.$t('bank_card.branded_card_category'));
      }
      if (!this.order_form.amount) {
        return this.message.ismessage('error',this.$t('bank_card.order_num'));
      }
      if (this.order_form.amount*1 > this.left_amount*1) {
        return this.message.ismessage('error',this.$t('new1_txt.order_exceed',{num: this.left_amount}));
      }
      if (this.order_form.amount*1 < this.min_amount*1) {
        return this.message.ismessage('error',this.$t('new1_txt.order_less',{num: this.min_amount}));
      }
      const res = await createOrder({
        tx_id:this.order_id,
        card_level:this.card_level,
        card_category:this.order_form.card_name,
        amount:this.order_form.amount,
        remark:this.order_form.remark
      });
      if (res.data.code !== 200) {
        return this.message.ismessage('error',res.data.msg);
      }
      this.message.ismessage('success',this.$t('bank_card.Order_success'));
      this.place_order_dlg = false;
      this.get_list();
    },

    to_info(){
      this.$router.push({path:'/check_order',query:{order_id:this.order_id}});
    },
    async view_contract(){
      this.$router.push({path:'/contract_management_info',query:{id:this.order_id}});
    },
    


  },

};
</script>

<style scoped>
.t_h1_top{
  margin-top: 40px;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  margin-bottom: 16px;
}
.t_h1_box{
  background: #314B69;
  border-radius: 16px;
  box-sizing: border-box;
  padding: 28px;
  padding-bottom: 6px;
}
.zdy_form >>> .el-form-item{
  display: inline-block;
  width: 252px;
  margin-right: 20px;
}
.zdy_form >>> .el-date-editor.el-input,
.zdy_form >>> .el-select{
  width: 100%;
}
.zdy_form >>> .el-form-item:last-child{
  margin-right: 0;
}
.zdy_form >>> .el-form-item__label {
  padding: 0;
  line-height: inherit;
  margin-bottom: 8px;
  color: rgba(255, 255, 255, 0.6);
}
.zdy_form >>> .el-input__inner{
  background: #223C58;
  border: none;
  border-radius: 8px;
  color: #fff;
}
.reset_btn,
.reset_btn:hover,
.reset_btn:active,
.reset_btn:focus{
  color: #DEB981;
  border-color: #DEB981;
  background: transparent;
  min-width: 120px;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  border-radius: 4px;
}
.apply_btn,
.apply_btn:hover,
.apply_btn:active,
.apply_btn:focus{
  min-width: 120px;
  border-color: #F1C788;
  background: linear-gradient(90deg, #F1C788 0.42%, #E3A84E 100.42%);
  box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
  border-radius: 4px;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  color: #04182A;
  margin-left: 20px;
}
.zdy_form .btn_box{
  width: auto;
}
.t_h2_box{
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  align-items: center;
}
.t_h2_txt1{
  font-style: normal;
  font-size: 14px;
  line-height: 26px;
  text-align: right;
}
.t_h2_txt2{
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  color: rgba(255, 255, 255, 0.8);
}
.export_btn,
.export_btn:hover,
.export_btn:active,
.export_btn:focus{
  color: #DEB981;
  border-color: #DEB981;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  /* min-width: 120px; */
  background: transparent;
}
.icon_width{
  width: 20px;
  vertical-align: middle;
  cursor: pointer;
}
.color_red{
  color: #F35F65;
}
.zdy_tab_header >>> .el-table tr th:last-child, .zdy_tab_header >>> .el-table__body tr td:last-child{
  padding-left: 0 !important;
}
.btn_icon{
  width: 19px;
  vertical-align: middle;
  margin-right: 12px;
}
.tab_btn1{
  height: 32px;
  border: 1px solid #DEB981;
  border-radius: 4px;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  color: #DEB981;
  background: transparent;
  margin-top: 5px;
}
.tab_btn2{
  height: 32px;
  border: 1px solid #FF4646;
  border-radius: 4px;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  color: #FF4646;
  background: transparent;
  margin-top: 10px;
}
.top_text{
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #FFFFFF;
  margin-bottom: 20px;
  word-break: break-word;
}
.dlg_form >>> .el-textarea__inner {
  background: #223C58;
  border-color: #223C58;
  color: #fff;
  height: 100px;
}

.confirm_btn_bgc,
.confirm_btn_bgc:hover,
.confirm_btn_bgc:focus,
.confirm_btn_bgc:active{
  background: #F35F65;
  border-color: #F35F65;
  color: #fff;
}
/* ---08-16 新增 --- */
.top_text2{
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  color: #FFFFFF;
  margin-bottom: 10px;
  word-break: break-word;
}
.info_1{
  display: flex;
  border-bottom: 1px solid #314B69;
  box-sizing: border-box;
  padding: 20px 0;
}
.info_1_left{
  width: 60%;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  color: #FFFFFF;
}
.info_1_right{
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: #FFFFFF;
  opacity: 0.6;
}
.top_text3{
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: #FFFFFF;
  opacity: 0.6;
}
.amount_box{
  box-sizing: border-box;
  padding: 20px 0;
  border-bottom: 1px solid #223C58;
}
.top_text4{
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  color: #FFFFFF;
  margin-bottom: 8px;
}
.top_text5{
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: #FFFFFF;
  opacity: 0.6;
}
.top_text5_2:nth-child(8){
  padding-top: 10px;
}
.top_text5_2{
  padding-top: 2px;
}
/* -- 输入下拉 选择币种 */
.zdy_input >>> .el-input__inner{
  /* width: 224px; */
  height: 68px;
  background: #223C58;
  border: 1.5px solid rgba(49, 72, 105, 0.1);
  border-radius: 8px 0px 0px 8px;
  display: inline-block;
  font-size: 24px;
  color: #fff;
}
.zdy_input >>> .el-input{
  width: 100%;
}
.zdy_input{
  display: flex;
}
.zdy_form >>> .el-form-item__label{
  line-height: inherit;
  padding: 0;
  padding-bottom: 8px;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  color: #fff;
}
.type_box{
  /* width: 154px; */
  width: 170px;
  height: 68px;
  border-radius: 8px 0 0 8px;
  cursor: pointer;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background: #041728;
}
.type_box1{
  display: flex;
  align-items: center;
  cursor: pointer;
}
.type_box1 img{
  width: 26px;
  vertical-align: middle;
  margin-right: 8px;
}
.type_box2{
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
}
.type_box3{
  color: rgba(255, 255, 255, 0.8);
}
.bz_list{
  box-sizing: border-box;
  padding: 8px;
}
.bz_list1{
  margin-bottom: 10px;
}
.bz_list .bz_list1:last-child{
  margin-bottom: 0;
}
.inp_btm_tit{
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  color: rgba(255, 255, 255, 0.6);
  margin-top: 12px;
}
/* ----over---- */
.box_margin{
  box-sizing: border-box;
  padding: 8px 0 12px;
}
.top_text6{
  margin-top: 25px;
  margin-bottom: 8px;
}
.top_text7{
  /* padding: 18px 12px 20px;
  background: #041728; */
  border-radius: 8px;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  color: #FFFFFF;
  display: flex;
  align-items: center;
}
.div_num{
  flex: 1;
  background: #223C58;
  text-align: right;
  height: 68px;
  line-height: 68px;
  box-sizing: border-box;
  padding-right: 15px;
  border-radius: 0 8px 8px 0;
}
.top_text7_2{
  padding: 18px 12px 20px;
  background: #041728;
  border-radius: 0 8px 8px 0;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  color: #FFFFFF;
  min-width: 120px;
  text-align: center;
}
.top_text8{
  display: flex;
  margin-top: 12px;
}
.top_text8>div{
  width: 50%;
}
.top_text9{
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  color: #FFFFFF;
  opacity: 0.6;
}
.top_text10{
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  color: #FFFFFF;
}
.warning_red{
  background: #FEDFE0;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 12px 15px;
  display: flex;
  align-items: center;
  margin-top: 8px;
}
.warning_yellow{
  background: #E8DAC8;
}
.warning_red_icon i{
  color: #F35F65;
  font-size: 25px;
  margin-right: 12px;
}
.warning_red_text{
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 20px;
  color: #F35F65;
}
.warning_yellow_icon i,
.warning_yellow_text{
  color: #B28247;
}
.top_up_link{
  color: #041728;
  text-decoration: underline;
}
.yellow{
  color: #d9b680;
  cursor: pointer;
  margin-right: 10px;
}
.inp_btm_title{
  line-height: initial;
  margin-top: 5px;
}

/* ---------- */
.contract_box{
  display: flex;
  flex-wrap: wrap;
  border: 1px solid #414B5F;
  padding: 10px;
  padding-bottom: 0;
  box-sizing: border-box;
}
.con_left{
  width: 55%;
  padding-bottom: 5px;
  margin-bottom: 5px;
  word-wrap: break-word;
  word-break: break-word;
  border-bottom: 1px solid #414B5F;
}
.con_right{
  width: 42%;
  padding-bottom: 5px;
  margin-bottom: 5px;
  word-wrap: break-word;
  word-break: break-word;
  border-bottom: 1px solid #414B5F;
  border-left: 1px solid #414B5F;
  padding-left: 5px;
}
.contract_box_border{
  border-bottom: none;
}
.con_rate_box{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}


.p_order_body{
  width: 92%;
  margin: auto;
  padding-top: 15px;
}
.p_ord_row1{
  background: #04182A;
  border-radius: 16px;
  box-sizing: border-box;
  padding: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}
.p_ord_row1_i{
  flex: 1;
  border-right: 1px solid rgba(255, 255, 255, 0.24);
  text-align: center;
}
.p_ord_row1_i:last-child{
  border: none;
}
.p_ord_row1_i1{
  font-size: 22px;
  /* margin-bottom: 4px; */
}
.p_ord_row1_i2{
  color: rgba(255, 255, 255, 0.8);
}
.p_ord_row2{
  margin-top: 15px;
}


</style>

<style>
.cards_table .row_2_bgc,
.cards_table .row_2_bgc .el-table__cell{
  background: #172C43 !important;
}
.cards_table .row_2_bgc:hover{
  background: #172C43 !important;
}
.cards_table .el-table--striped .el-table__body .row_2_bgc ,
.cards_table .el-table--striped .el-table__body .row_2_bgc td.el-table__cell{
  background: #172C43 !important;
}
/* ------ */
.bz_pop{
  color: #fff;
  font-size: 15px;
  background: #041E35;
  box-shadow: 0px 0px 4px #4f78a9;
  /* border-radius: 16px; */
  border: none;
  box-sizing: border-box;
  transform: translateY(-10px);
}
.bz_pop .popper__arrow {
  display: none;
}
.btm_text{
  line-height: initial;
  padding-top: 5px;
}
.show-pwd {
  position: absolute;
  right: 10px;
  top: 1px;
  font-size: 16px;
  cursor: pointer;
  user-select: none;
}
.show-pwd img {
  width: 18px;
}

.c_top_title{
  font-size: 16px;
  margin-bottom: 20px;
}
.num_item{
  box-sizing: border-box;
  padding: 20px 30px;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #314b69;
}
.num_item div{
  margin-bottom: 7px;
}
.num_item div:last-child{
  margin-bottom: 0;
}
.c_top_num_box{
  display: flex;
  flex-wrap: wrap;
}
.c_top_num_box .num_item{
  margin-right: 20px;
  margin-bottom: 20px;
  flex: auto;
}
/* .c_top_num_box .num_item:last-child{
  margin-right: 0;
} */
.el-input.is-disabled .el-input__inner {
  color: #000;
}


</style>

<style>
@media screen and (max-width: 850px) {
  .app_dlg{
    top: 0 !important;
    left: 0 !important;
    transform: translate(0,10px) !important;
  }
}
</style>

<style scoped>
@media screen and (max-width: 850px) {
  .t_h2_box {
    display: block;
    margin-top: 0;
    align-items: left;
  }
  .t_h1_top {
    margin-top: 0;
  }
  .t_h2_txt1 {
    display: flex;
    flex-direction: column;
    align-items: end;
  }
  .num_item{
    width: 100%;
    margin-right: 0;
    margin-bottom: 15px;
  }
  .t_h2_txt1 >>> .el-button{
    margin-bottom: 10px;
  }

}
</style>

<style scoped>
/* info */
.th_info{
    background: #314B69;
    border-radius: 16px;
}
.th_info_top{
    box-sizing: border-box;
    padding: 28px;
    border-bottom: 1.5px solid #041E35;
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 26px;
}
.th_info_main{
    box-sizing: border-box;
    padding: 28px;
}
.th_tit1{
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 18px;
    margin-bottom: 12px;
    margin-top: 20px;
}
.th_tit2{
    margin-bottom: 12px;
    display: flex;
}
.th_info_main .th_tit2:last-child{
    margin-bottom: 0;
}
.th_tit3{
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 18px;
    color: rgba(255, 255, 255, 0.6);
    width: 260px;
    margin-right: 28px;
    display: inline-block;
}
.th_tit4{
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    display: inline-block;
}
.title_bottom{
    margin-top: 30px;
}
.return_icon{
  cursor: pointer;
  margin-right: 10px;
}
.t_h2_txt1{
  font-style: normal;
  font-size: 20px;
  line-height: 26px;
  margin-bottom: 15px;
}
.fd_img_box{
    max-width: 260px;
    max-height: 160px;
    display: block;
    margin-bottom: 5px;
}
.stage_box{
    margin-bottom: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid #041E35;
}
</style>

<style scoped>
.i_table{
  /* border: 1px solid #041E35;
  box-sizing: border-box; */
  color: #B0BAC5;
  font-size: 15px;
  line-height: 18px;
  border-left: 1px solid #041E35;
}
.i_table_t1{
  display: flex;
}
.i_table_t2{
  width: 50%;
}
.i_table_t2 table{
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
}
.i_table_t2 table tr:nth-child(even){
  background-color: #39526F;
}
.i_table_t2 td{
  box-sizing: border-box;
  padding: 10px 15px;
  border: 1px solid #041E35;
  border-left: none;
}
/* .i_table_t2 tr{
  display: flex;
  width: 100%;
} */
.td_left{
  /* width: 70%; */
}
.td_right{
  width: 25%;
  color: #fff;
}
.div_br{
  box-sizing: border-box;
  padding: 10px 15px;
  border-right: 1px solid #041E35;
}
.font_color{
  color: #fff;
}
.Notes_box{
  border-left: 1px solid #314b69;
  margin-left: -1px;
  box-sizing: border-box;
  padding-top: 10px;
}
.Notes_box>div{
  margin-bottom: 3px;
}

@media screen and (max-width: 1210px) {
  .i_table_t1 {
    display: block;
  }
  .i_table_t2 {
    width: 100%;
  }
}

</style>
